import { type ReactNode } from 'react';
import { Box } from '@mui/material';
import { type EmployeeDetailsTab } from '../../constants';
import { getTabId, getTabPanelId } from '../../helpers';

type TabPanelProps = {
  value: EmployeeDetailsTab;
  currentTab: EmployeeDetailsTab;
  children?: ReactNode;
};

export const TabPanel = ({ value, currentTab, children }: TabPanelProps) => (
  <Box
    role="tabpanel"
    hidden={value !== currentTab}
    id={getTabPanelId(value)}
    aria-labelledby={getTabId(value)}
    sx={{ padding: '32px 0' }}
  >
    {children}
  </Box>
);
